const translations = {
    badPath: `We couldn't find the page you were looking for.`
};

export default translations;
